export const renderUserRole = (role: string) => {
  switch (role) {
    case 'UR100001':
      return '엣지크로스 최고s관리자';
    case 'UR100002':
      return '엣지크로스 관리자';
    case 'UR100003':
      return '최고 관리자';
    case 'UR200004':
      return '일반 사용자';
  }
};

export const renderGradId = (gradId: number) => {
  switch (gradId) {
    case 20:
      return '최고 관리자';
    case 21:
      return '중간 관리자';
    case 22:
      return '일반 유저';
    case 23:
      return '임시 계정';
    case 10:
      return '최고 관리자';
    case 11:
      return '중간 관리자';
    case 12:
      return '일반 유저 ';
    case 13:
      return 'AS/CS 담당자';
  }
};
